import { render, staticRenderFns } from "./UpdatesOrdered.vue?vue&type=template&id=c843295a&scoped=true&"
import script from "./UpdatesOrdered.vue?vue&type=script&lang=js&"
export * from "./UpdatesOrdered.vue?vue&type=script&lang=js&"
import style0 from "./UpdatesOrdered.vue?vue&type=style&index=0&id=c843295a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c843295a",
  null
  
)

export default component.exports